export default "__VITE_ASSET__97980a8f__"